module.exports = __webpack_public_path__ + "static/media/topr-callout-bg.0e015942.png";